'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BizObjectivesMap;

var _BizObjectives = require('self-service-api/constants/BizObjectives');

var _BizObjectives2 = _interopRequireDefault(_BizObjectives);

var _Features = require('self-service-api/constants/Features');

var _Features2 = _interopRequireDefault(_Features);

var _ObjectDefaults = require('self-service-api/constants/ObjectDefaults');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BizObjectivesMap = (_BizObjectivesMap = {}, _defineProperty(_BizObjectivesMap, _BizObjectives2.default.CREATE_ENGAGING_CONTENT, {
  features: [_Features2.default.LANDING_PAGES, _Features2.default.CONTENT_CREATION_TOOLS],
  breakoutData: null // just showing that this is part of the ObjectDefault
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.PERSONALIZE_EXPERIENCES, {
  features: [_Features2.default.VIDEO_HOSTING_MANAGEMENT, _Features2.default.CALLS_TO_ACTION, _Features2.default.AB_TESTING, _Features2.default.SMART_CONTENT]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.GET_FOUND_ONLINE_CMS, {
  features: [_Features2.default.SEO_CONTENT_STRATEGY]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.CAPTURE_CONVERT_LEADS_CMS, {
  features: [_Features2.default.LIVE_CHAT, _Features2.default.CONVERSATIONAL_BOTS, _Features2.default.POPUP_FORMS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.CAPTURE_CONVERT_LEADS_MARKETING, {
  features: [_Features2.default.AD_MANAGEMENT, _Features2.default.LIVE_CHAT, _Features2.default.CONVERSATIONAL_BOTS, _Features2.default.FORMS, _Features2.default.POPUP_FORMS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.ENGAGE_LEADS, {
  features: [_Features2.default.EMAIL_MARKETING, _Features2.default.AD_RETARGETING]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.UNDERSTAND_LEADS, {
  features: [_Features2.default.CONTACT_WEBSITE_ACTIVITY,
  // Features.CONTACT_AND_COMPANY_INSIGHTS,
  _Features2.default.LIST_SEGMENTATION]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.AUTOMATE_MARKETING, {
  features: [
  // TODO: Add features Email automation, Ads automation, Social automation, Task automation
  // Features.EMAIL_ADS_SOCIAL_TASK_AUTOMATION, // Should get broken down into separate "automations" (see comment above)
  _Features2.default.MARKETING_AUTOMATION, _Features2.default.SMART_CONTENT]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.GET_FOUND_ONLINE_MARKETING, {
  features: [_Features2.default.CONTENT_CREATION_TOOLS, _Features2.default.SEO_CONTENT_STRATEGY, _Features2.default.SOCIAL_MEDIA]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.OPTIMIZE_CONVERSION, {
  features: [_Features2.default.AB_TESTING, _Features2.default.LANDING_PAGES, _Features2.default.CALLS_TO_ACTION, _Features2.default.VIDEO_HOSTING_MANAGEMENT]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.MEASURE_REVENUE, {
  features: [_Features2.default.WEBSITE_TRAFFIC_ANALYTICS, _Features2.default.CAMPAIGN_REPORTING, _Features2.default.ATTRIBUTION_REPORTING, _Features2.default.CUSTOM_REPORTS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.MANAGE_TEAMS_AND_BRANDS, {
  features: [_Features2.default.CONTENT_PARTITIONING, _Features2.default.HIERARCHICAL_TEAMS, _Features2.default.SINGLE_SIGN_ON, _Features2.default.SOCIAL_PERMISSIONS, _Features2.default.ADDITIONAL_DOMAINS, _Features2.default.EMAIL_SEND_FREQUENCY_CAP]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.EXTEND_PLATFORM, {
  features: [_Features2.default.CALCULATED_PROPERTIES, _Features2.default.CMS_MEMBERSHIP]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.ANALYZE_FULL_CONTROL, {
  features: [_Features2.default.FILTERED_ANALYTICS_VIEW, _Features2.default.EVENTS_API]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.STREAMLINE_OUTREACH, {
  features: [_Features2.default.EMAIL_TRACKING_NOTIFICATIONS, _Features2.default.SEQUENCES, _Features2.default.CALLING]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.CONNECT_WITH_PROSPECTS, {
  features: [_Features2.default.LIVE_CHAT, _Features2.default.MEETINGS, _Features2.default.EMAIL_SCHEDULING]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.TRACK_ITERATE_IMPROVE, {
  features: [_Features2.default.DEAL_PIPELINE, _Features2.default.REP_PRODUCTIVITY_PERFORMANCE]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.AUTOMATE_SALES_PROCESS, {
  features: [_Features2.default.DEAL_STAGE_TASK_LEAD_ROTATION_AUTOMATION, _Features2.default.WORKFLOWS_EXTENSIONS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.PERSONALIZE_OUTREACH, {
  features: [
  // Features.VIDEO_HOSTING_MANAGEMENT,
  _Features2.default.VIDEO_CREATION, _Features2.default.SEQUENCE_QUEUES,
  // Features.EMAIL_RECOMMENDATIONS,
  _Features2.default.QUOTES]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.KEEP_DATA_ORGANIZED, {
  features: [_Features2.default.PRODUCTS,
  // Features.ACTIVITY_TYPES,
  _Features2.default.TEAMS,
  // TODO: add feature advanced data management
  _Features2.default.SALESFORCE_INTEGRATION, _Features2.default.MULTI_CURRENCY, _Features2.default.REQUIRED_FIELDS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.COACH_AND_ENABLE, {
  features: [_Features2.default.PLAYBOOKS, _Features2.default.GOALS, _Features2.default.CALL_TRANSCRIPTION, _Features2.default.CALCULATED_PROPERTIES, _Features2.default.PREDICTIVE_LEAD_SCORING]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.CLOSE_MORE_DEALS, {
  features: [_Features2.default.QUOTE_BASED_WORKFLOWS, _Features2.default.ESIGN, _Features2.default.RECURRING_REVENUE_TRACKING]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.MANAGE_GROWING_TEAM, {
  features: [_Features2.default.USER_ROLES, _Features2.default.SINGLE_SIGN_ON]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.TRACK_CUSTOMER_COMMS, {
  features: [_Features2.default.TICKETING, _Features2.default.LIVE_CHAT, _Features2.default.CONVERSATIONS_INBOX, _Features2.default.CALLING, _Features2.default.CONVERSATIONAL_BOTS, _Features2.default.TEAM_EMAIL]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.MAXIMIZE_PRODUCTIVITY, {
  features: [_Features2.default.SNIPPETS, _Features2.default.TEMPLATES, _Features2.default.SEQUENCES, _Features2.default.MEETINGS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.MEASURE_EFFICIENCY, {
  features: [_Features2.default.TICKETS_CLOSED_REPORTS, _Features2.default.REP_PRODUCTIVITY_REPORTS, _Features2.default.TIME_TO_CLOSE_REPORTS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.DELIGHT_CUSTOMERS, {
  features: [_Features2.default.TICKET_STATUS, _Features2.default.TICKET_ROUTING, _Features2.default.TASK_AUTOMATION, _Features2.default.MULTIPLE_TICKET_PIPELINES]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.HELP_CUSTOMERS_HELP_THEMSELVES, {
  features: [_Features2.default.KNOWLEDGE_BASE, _Features2.default.VIDEO_HOSTING_MANAGEMENT]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.MEASURE_IMPROVE_CUSTOMER_EXPERIENCE, {
  features: [_Features2.default.CUSTOM_REPORTS, _Features2.default.NPS_SURVEYS, _Features2.default.CUSTOMER_EXPERIENCE_SURVEYS, _Features2.default.CUSTOMER_SUPPORT_SURVEYS, _Features2.default.INSIGHTS_DASHBOARD]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.DELIVER_EXCEPTIONAL_SERVICE, {
  features: [_Features2.default.PLAYBOOKS, _Features2.default.GOALS]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.MANAGE_MULTIPLE_TEAMS, {
  features: [_Features2.default.HIERARCHICAL_TEAMS, _Features2.default.USER_ROLES, _Features2.default.SINGLE_SIGN_ON, _Features2.default.SLACK, _Features2.default.CALCULATED_PROPERTIES]
}), _defineProperty(_BizObjectivesMap, _BizObjectives2.default.ENABLE_SELF_SERVICE, {
  features: [_Features2.default.WEBHOOKS]
}), _BizObjectivesMap);

var exportedMap = {};

Object.keys(BizObjectivesMap).forEach(function (bizObjKey) {
  exportedMap[bizObjKey] = _extends({}, _ObjectDefaults.BizObjectivesMapDefault, BizObjectivesMap[bizObjKey]);
});

exports.default = exportedMap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/BizObjectivesMap.js
// module id = 760
// module chunks = 3 4